import React, { useMemo, useState } from "react";
import { SelectCars } from "ui/componentes/CarSelect";
import { SwitchFieldFormik } from "ui/componentes/Form/SwitchFieldFormik";
import { Button, Divider, Grid, IconButton } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import { Championship, convertToClasses } from "api/model/Championship";
import groupBy from "lodash/groupBy";
import pickBy from "lodash/pickBy";
import { BoxCard } from "ui/componentes/BoxCard";
import { Subtitle } from "ui/componentes/Layout";
import { Delete } from "@material-ui/icons";
import { Car } from "api/model/Car";

const onSelectCar = (push) => (cars: Car[]) => {
    if (!cars || cars.length === 0) {
        return;
    }
    cars.map(
        ({
            id,
            brandId,
            name,
            model,
            carIRacingID,
            className,
            classIRacingID,
        }) => ({
            id,
            brandId,
            name,
            model,
            carIRacingID,
            className,
            classIRacingID,
        })
    ).forEach((car) => push(pickBy(car, (value) => value !== undefined)));
};

const ChampionshipCars = () => {
    const { values } = useFormikContext<Championship>();
    const [openSelectCars, setOpenSelectCars] = useState(false);
    const filterCarsOptions = useMemo(() => {
        return [
            (car) => {
                if (values.cars) {
                    return !values.cars.map((d) => d.id).includes(car.id || "");
                }
                return true;
            },
        ];
    }, [values.cars]);

    const indexCarByID = useMemo(() => {
        const indexCarByID = {};
        values.cars.forEach((car, index) => (indexCarByID[car.id] = index));
        return indexCarByID;
    }, [values]);

    const classes = useMemo(() => {
        return convertToClasses(values.cars);
    }, [values.cars]);

    const carsByClassID = useMemo(() => {
        return groupBy(values.cars, (car) => car.classIRacingID);
    }, [values.cars]);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <SwitchFieldFormik name="isMultiClass" label="Multi classe?" />
            </Grid>
            <Grid item xs={12}>
                <Button color="primary" onClick={() => setOpenSelectCars(true)}>
                    Selecionar carros
                </Button>
            </Grid>
            <FieldArray name="cars">
                {({ push, remove }) => {
                    return (
                        <>
                            <Grid item xs={12}>
                                <SelectCars
                                    open={openSelectCars}
                                    onSelectCars={onSelectCar(push)}
                                    onClose={() => setOpenSelectCars(false)}
                                    filterOptions={filterCarsOptions}
                                />
                            </Grid>
                            {classes.map((className, index) => (
                                <Grid item md={4} xs={12} key={index}>
                                    <BoxCard
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        padding={2}
                                    >
                                        <Subtitle
                                            text={
                                                className.name ||
                                                className.id ||
                                                "Sem classe definida"
                                            }
                                            color="textSecondary"
                                        />
                                        <Divider
                                            style={{
                                                marginBottom: 20,
                                                marginTop: 5,
                                                width: "100%",
                                            }}
                                        />
                                        {carsByClassID[className.id].map(
                                            (car) => (
                                                <BoxCard
                                                    mb={2}
                                                    key={car.id}
                                                    id={car.id}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignContent="center"
                                                    width="100%"
                                                >
                                                    {car.name}
                                                    <IconButton
                                                        style={{ padding: 0 }}
                                                        onClick={() =>
                                                            remove(
                                                                indexCarByID[
                                                                    car.id
                                                                ]
                                                            )
                                                        }
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </BoxCard>
                                            )
                                        )}
                                    </BoxCard>
                                </Grid>
                            ))}
                        </>
                    );
                }}
            </FieldArray>
        </Grid>
    );
};

export { ChampionshipCars };
